import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Box, Card, Typography, useTheme, useMediaQuery } from "@mui/material";
import { getDaysAgo } from "../../util/theme";
const NewsCard = ({ noticia, onClick }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    return (_jsxs(Card, Object.assign({ sx: {
            width: isMobile ? "130% !important" : "340px !important",
            height: isMobile ? "auto !important" : "420px !important",
            minWidth: isMobile ? "130% !important" : "340px !important",
            minHeight: isMobile ? "auto !important" : "420px !important",
            gap: isMobile ? "8px" : "16px",
            borderRadius: isMobile ? "12px" : "20px 20px 20px 0",
            background: "var(--hemoes-news-card-bg)",
            borderStyle: "solid",
            borderColor: "var(--hemoes-news-card-border-color)",
            borderWidth: "var(--hemoes-news-card-border-width)",
            borderTopWidth: isMobile
                ? "var(--hemoes-news-card-border-top-width-mobile)"
                : "var(--hemoes-news-card-border-top-width)",
            marginLeft: isMobile ? "-15% !important" : "-6% !important",
            marginTop: isMobile ? "-20% !important" : "-4% !important",
            boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
            display: "flex",
            flexDirection: isMobile ? "row" : "column",
            cursor: "pointer",
            overflow: "hidden",
            margin: isMobile ? "0 0 65px 0" : "0 65px",
            padding: isMobile ? "16px" : "0",
        }, onClick: onClick, "data-testid": `news-card-${noticia.title
            .toLowerCase()
            .replace(/\s+/g, "-")
            .substring(0, 20)}` }, { children: [_jsx(Box, Object.assign({ sx: {
                    width: isMobile ? "120px" : "340px",
                    height: isMobile ? "120px" : "220px",
                    gap: isMobile ? "12px" : "16px",
                    borderRadius: isMobile ? "8px" : "20px 20px 0 0",
                    overflow: "hidden",
                    flexShrink: 0,
                } }, { children: _jsx("img", { src: `${process.env.PORTAL_URL}/api/hemoes/assets/${noticia.thumbnail}`, alt: noticia.title, style: {
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                    } }) })), _jsxs(Box, Object.assign({ sx: {
                    padding: isMobile ? "0 0 0 16px" : "20px",
                    display: "flex",
                    flexDirection: "column",
                    flex: 1,
                    justifyContent: "space-between",
                    minWidth: 0,
                    background: "var(--hemoes-news-card-text-bg)",
                } }, { children: [_jsxs(Box, { children: [_jsxs(Box, Object.assign({ sx: {
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    mb: isMobile ? 1.5 : 2,
                                    flexWrap: "wrap",
                                } }, { children: [_jsx(Typography, Object.assign({ sx: {
                                            fontFamily: "Montserrat, sans-serif",
                                            fontWeight: 500,
                                            fontSize: isMobile
                                                ? "calc(12px + var(--accessibility-font-delta, 0px))"
                                                : "calc(14px + var(--accessibility-font-delta, 0px))",
                                            lineHeight: isMobile ? "16px" : "18px",
                                            letterSpacing: "0.5px",
                                            color: "var(--hemoes-news-card-meta)",
                                        } }, { children: "Sa\u00FAde" })), _jsx(Typography, Object.assign({ sx: {
                                            fontFamily: "Montserrat, sans-serif",
                                            fontWeight: 500,
                                            fontSize: isMobile
                                                ? "calc(12px + var(--accessibility-font-delta, 0px))"
                                                : "calc(14px + var(--accessibility-font-delta, 0px))",
                                            lineHeight: isMobile ? "16px" : "18px",
                                            letterSpacing: "0.5px",
                                            color: "var(--hemoes-news-card-meta)",
                                        } }, { children: getDaysAgo(noticia.date_updated) }))] })), _jsx(Typography, Object.assign({ sx: {
                                    fontFamily: "Montserrat, sans-serif",
                                    fontWeight: 500,
                                    fontSize: isMobile
                                        ? "calc(16px + var(--accessibility-font-delta, 0px))"
                                        : "calc(18px + var(--accessibility-font-delta, 0px))",
                                    lineHeight: isMobile ? "20px" : "24px",
                                    letterSpacing: "0.46px",
                                    verticalAlign: "middle",
                                    color: "var(--hemoes-news-card-title)",
                                    mb: isMobile ? 1.5 : 2,
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    display: "-webkit-box",
                                    WebkitLineClamp: isMobile ? 3 : 3,
                                    WebkitBoxOrient: "vertical",
                                    wordWrap: "break-word",
                                    overflowWrap: "break-word",
                                } }, { children: noticia.title }))] }), _jsx(Box, Object.assign({ sx: { display: "flex", justifyContent: "flex-end" } }, { children: _jsxs(Typography, Object.assign({ sx: {
                                fontFamily: "Montserrat, sans-serif",
                                fontWeight: 600,
                                fontSize: isMobile
                                    ? "calc(13px + var(--accessibility-font-delta, 0px))"
                                    : "calc(14px + var(--accessibility-font-delta, 0px))",
                                lineHeight: isMobile ? "18px" : "20px",
                                letterSpacing: "0.7px",
                                textAlign: "center",
                                verticalAlign: "middle",
                                color: "var(--hemoes-news-card-link)",
                                display: "flex",
                                alignItems: "center",
                                gap: 0.5,
                            } }, { children: ["Acessar completa", _jsx("span", Object.assign({ style: {
                                        fontSize: isMobile
                                            ? "calc(18px + var(--accessibility-font-delta, 0px))"
                                            : "calc(20px + var(--accessibility-font-delta, 0px))",
                                    } }, { children: "\u2192" }))] })) }))] }))] })));
};
export const NewsBar = ({ noticias, navegatePage }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    return (_jsx(Box, Object.assign({ sx: {
            width: isMobile ? "100%" : "1000px",
            height: isMobile ? "auto" : "380px",
            gap: isMobile ? "20px" : "32px",
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            justifyContent: isMobile ? "flex-start" : "space-between",
            padding: isMobile ? "8px 16px" : "0",
            mt: isMobile ? 1 : 0,
        } }, { children: noticias.map((noticia, index) => (_jsx(NewsCard, { noticia: noticia, onClick: () => navegatePage(noticia) }, index))) })));
};
